var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ログイン(お客様) */
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import PasswordExpiredDialog from '../molecules/PasswordExpiredDialog';
import ResponseDialog from '../molecules/ResponseDialog';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../Common';
var ApplicantLogin = function () {
    // ログイン情報のState
    var _a = useState(''), password = _a[0], setPassword = _a[1];
    var _b = useState(''), login_id = _b[0], setLoginId = _b[1];
    var _c = useState(), login_error_message = _c[0], setLoginResult = _c[1];
    var _d = useState(false), is_connecting = _d[0], setIsConnecting = _d[1];
    var _e = useState(false), is_loading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), show = _f[0], setShow = _f[1];
    var _g = useState(false), show_error_dialog = _g[0], setShowErrorDialog = _g[1];
    // Note sakuma ログインエラーメッセージとは別にstateを持つ
    var _h = useState(''), token_mimatch_message = _h[0], setTokenMimatchMessage = _h[1];
    // 言語
    var _j = useTranslation(), t = _j.t, i18n = _j.i18n;
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
    }, []);
    // パスワード有効期限切れダイアログでOKをクリックしたらパスワード変更画面へ遷移
    var handleClickOk = function () {
        setShow(false);
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/password/change");
    };
    // ログインボタンのクリックイベントを定義
    var handleClick = function () {
        // ログイン情報をStateへセット
        var login_info = { loginId: login_id, password: password };
        var login = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post('/mypage/loginproc', login_info)];
                    case 1:
                        response = _a.sent();
                        // ログイン成功
                        // 受付CDと受付IDの有無を判定
                        if (typeof response.data.reception_cd !== 'undefined' &&
                            typeof response.data.reception_id !== 'undefined') {
                            // あり
                            // 該当の案件詳細へ遷移する
                            location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + response.data.reception_cd + "/" + response.data.reception_id;
                        }
                        else {
                            // なし
                            // 案件一覧へ遷移
                            location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/mypage/list";
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        // トークン有効期限切れ
                        if (error_1.response.data.is_token_mismatch) {
                            setTokenMimatchMessage(error_1.response.data.message);
                            setShowErrorDialog(error_1.response.data.is_token_mismatch);
                        }
                        else {
                            setLoginResult(error_1.response.data.message);
                            // パスワードの有効期限切れ判定
                            if (typeof error_1.response.data.password_expired !== 'undefined' &&
                                error_1.response.data.password_expired) {
                                // パスワードの有効期限切れ
                                // ダイアログを表示
                                setShow(true);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // ログイン処理
        login();
    };
    /**
     * モーダルを非表示にし、画面をリロードする
     */
    var reload = useCallback(function () {
        setShowErrorDialog(false);
        location.reload();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: "\u30ED\u30B0\u30A4\u30F3", content: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "mx-2" },
                    React.createElement(Annotation, { text: "\u3054\u767B\u9332\u306E\u30ED\u30B0\u30A4\u30F3ID\uFF08\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF09\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" })),
                React.createElement("div", { className: "mt-3" }),
                React.createElement("div", null,
                    React.createElement(Text, { id: "email", label: "\u30ED\u30B0\u30A4\u30F3ID", value: login_id, placeholder: "", handleChange: function (event) { return setLoginId(event.target.value); }, disabled: false, maxlength: 200 }),
                    React.createElement(Text, { id: "password", label: "\u30D1\u30B9\u30EF\u30FC\u30C9", type: "password", value: password, placeholder: "", handleChange: function (event) { return setPassword(event.target.value); }, disabled: false, maxlength: 200 })),
                login_error_message !== undefined ? (React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                    React.createElement(Col, null),
                    React.createElement(Col, { md: 9, className: "alert-danger alert-danger-custom" }, login_error_message))) : null) }),
        React.createElement("div", { className: "mt-5" }),
        React.createElement(CenterButton, { label: "\u30ED\u30B0\u30A4\u30F3", handleClick: handleClick }),
        React.createElement("div", { className: "mt-3" }),
        React.createElement(LoadingModal, { show: is_loading }),
        React.createElement(PasswordExpiredDialog, { okCallback: handleClickOk, open: show, t: t }),
        React.createElement(ResponseDialog, { is_confirm: true, title: "\u6709\u52B9\u671F\u9650\u5207\u308C", body: token_mimatch_message, show: show_error_dialog, ClickCallBackConfirm: reload, t: t })));
};
if (document.getElementById('applicant-login')) {
    ReactDOM.render(React.createElement(ApplicantLogin, null), document.getElementById('applicant-login'));
}
